import {useEffect} from 'react'

import Loading from '../../common/components/List/Loading.js'
import {
  refreshTransferList,
  transferListQuerySelector,
  isLoadingSelector,
} from './transferListFunctions.js'
import TransferListFooter from './TransferListFooter.js'
import Table from './Table.js'
import {useSelector} from '../../store.js'

export default function List() {
  const query = useSelector(transferListQuerySelector)
  const isLoading = useSelector(isLoadingSelector)

  useEffect(() => {
    refreshTransferList()
  }, [query])

  return (
    <>
      {isLoading ? (
        <div className="medium-12 columns list--empty-content margin-top-40 margin-bottom-40">
          <Loading />
        </div>
      ) : (
        <div className="medium-12 columns">
          <Table />
          <TransferListFooter />
        </div>
      )}
    </>
  )
}
